export default __webpack_public_path__ + "img/paBTvnyO.0144161f.svg";